<template>
  <validation-observer ref="providerObserver">
    <v-container fluid>
      <v-switch dense v-model="catalogActivatedProxy" :label="$t('findInStore.settings.activateCatalog')" />
      <v-card v-if="displayCatalogFields" outlined class="mt-3">
        <v-card-title>{{ $t('findInStore.settings.catalog') }}</v-card-title>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6">
              <validation-provider
                rules="required"
                :name="$t('findInStore.settings.catalogApiKey')"
                v-slot="{ errors }"
              >
                <v-text-field
                  hide-details="auto"
                  class="text-uppercase"
                  outlined
                  dense
                  v-model="settings.apiKey"
                  :label="$t('findInStore.settings.catalogApiKey')"
                  :error-messages="errors"
                  :type="showApiKey ? 'text' : 'password'"
                  :append-icon="showApiKey ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showApiKey = !showApiKey"
                  required
                  clearable
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="6">
              <validation-provider rules="required" :name="$t('findInStore.settings.catalogURL')" v-slot="{ errors }">
                <v-text-field
                  hide-details="auto"
                  class="text-uppercase"
                  outlined
                  dense
                  v-model="settings.url"
                  :label="$t('findInStore.settings.catalogURL')"
                  :error-messages="errors"
                  required
                  clearable
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="6">
              <validation-provider
                rules="required"
                :name="$t('findInStore.settings.catalogDefaultStore')"
                v-slot="{ errors }"
              >
                <v-text-field
                  hide-details="auto"
                  class="text-uppercase"
                  outlined
                  dense
                  v-model="settings.defaultStore"
                  :label="$t('findInStore.settings.catalogDefaultStore')"
                  :error-messages="errors"
                  required
                  clearable
                ></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </validation-observer>
</template>
<script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'

  export default {
    name: 'FindInStoreSettingsCatalog',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    props: {
      settings: {
        type: Object,
        required: true,
      },
      catalogActivated: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showApiKey: false,
      }
    },
    computed: {
      catalogActivatedProxy: {
        get() {
          return this.catalogActivated
        },
        set(value) {
          this.$emit('update:catalogActivated', !!value)
        },
      },
      displayCatalogFields() {
        return this.catalogActivated
      },
    },
    methods: {
      async hasErrors() {
        const valid = await this.$refs.providerObserver.validate()
        return !valid
      },
    },
  }
</script>
